<template>
  <el-dialog
    title="领用申请"
    :visible.sync="visible"
    width="560px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="task-info-bar">
      <span class="label">材料名称：</span>
      <span class="value">{{ materialName }}</span>
      <span
        class="label"
        style="margin-left:16px"
      >当前库存：</span>
      <span class="value">{{ stockCount }}{{ unit }}</span>
      <span
        v-if="stockCount <= 0"
        class="value"
        style="margin-left:16px; color:#e6a23c"
      >库存不足，无法申请</span>
    </div>

    <!-- 领用信息 -->
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="100px"
    >
      <el-form-item
        label="领用数量"
        prop="outCount"
      >
        <el-input-number
          v-model="form.outCount"
          :min="1"
          :max="stockCount || 9999"
          :precision="0"
          placeholder="请输入领用数量"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item
        label="用途说明"
        prop="purpose"
      >
        <el-input
          v-model="form.purpose"
          type="textarea"
          :rows="3"
          placeholder="请填写用途说明（必填）"
          maxlength="500"
          show-word-limit
        />
      </el-form-item>
      <el-form-item
        label="关联故障单"
        prop="faultId"
      >
        <el-select
          v-model="form.faultId"
          placeholder="选填，不选则需选择使用区域"
          filterable
          clearable
          style="width: 100%"
          :loading="faultLoading"
          no-data-text="暂无待处理故障单"
          @change="onFaultChange"
        >
          <el-option
            v-for="f in faultOptions"
            :key="f.uuid"
            :label="`${f.faultCode} - ${f.deviceName || ''}`"
            :value="f.uuid"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-show="!form.faultId"
        label="使用区域"
        prop="zoneAreaId"
      >
        <el-select
          v-model="form.zoneAreaId"
          placeholder="请选择一级使用区域"
          filterable
          style="width: 100%"
          :loading="areaLoading"
        >
          <el-option
            v-for="z in zoneAreaOptions"
            :key="z.uuid"
            :label="z.areaName"
            :value="z.uuid"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="form.remark"
          placeholder="备注信息"
          maxlength="500"
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">
        取消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        :disabled="stockCount <= 0"
        @click="handleSubmit"
      >
        提交申请
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
// 服务
import { materialService } from './material.service';
import { areaService } from '@/features/gnmk/area/area.service';
import { faultService } from '@/features/gnmk/fault/fault.service';
// 工具函数
import { downloadFromApiBlobResponse } from '@/features/common/utils/downloadFileUtil';

export default {
  name: 'ApplyOutDialog',
  data () {
    const validateZone = (rule, value, callback) => {
      if (this.form.faultId) {
        callback();
        return;
      }
      if (!value) {
        callback(new Error('未关联故障单时请请选择使用区域'));
        return;
      }
      callback();
    };
    return {
      visible: false,
      loading: false,
      faultLoading: false,
      areaLoading: false,
      areaTree: [],
      materialName: '',
      stockCount: 0,
      unit: '',
      faultOptions: [],
      form: {
        materialId: null,
        outCount: null,
        purpose: '',
        faultId: null,
        zoneAreaId: null,
        remark: ''
      },
      rules: {
        outCount: [{ required: true, message: '请输入领用数量', trigger: 'blur' }],
        purpose: [{ required: true, message: '请填写用途说明', trigger: 'blur' }],
        zoneAreaId: [{ required: true, validator: validateZone, trigger: 'change' }]
      }
    };
  },
  computed: {
    zoneAreaOptions () {
      return (this.areaTree || []).map((n) => ({
        uuid: n.uuid,
        areaName: n.areaName
      }));
    }
  },
  methods: {
    open (row) {
      this.visible = true;
      this.materialName = row.materialName;
      this.stockCount = row.stockCount;
      this.unit = row.unit || '';
      this.form = {
        materialId: row.uuid,
        outCount: null,
        purpose: '',
        faultId: null,
        zoneAreaId: null,
        remark: ''
      };
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
      this.loadActiveFaults();
      this.loadAreaTree();
    },
    loadAreaTree () {
      this.areaLoading = true;
      areaService.getAreaTree().then((res) => {
        this.areaTree = res.data || [];
      }).finally(() => {
        this.areaLoading = false;
      });
    },
    onFaultChange (val) {
      if (val) {
        this.form.zoneAreaId = null;
      }
    },
    loadActiveFaults () {
      this.faultLoading = true;
      faultService.queryFaultPage({ pageSize: 100, statusList: ['pending', 'reported'] }).then(res => {
        this.faultOptions = (res.data && res.data.rows) || [];
      }).finally(() => {
        this.faultLoading = false;
      });
    },
    handleClose () {
      this.visible = false;
    },
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.$confirm('提交后将自动生成领用单，进入待审批状态。确认提交？', '提交确认', {
          type: 'warning',
          confirmButtonText: '确认提交',
          cancelButtonText: '取消'
        }).then(() => {
          this.loading = true;
          materialService.applyAndDownloadOut(this.form).then((res) => {
            downloadFromApiBlobResponse(res, '材料领用单.docx');
            this.$message.success('申请已提交，等待审批');
            this.handleClose();
            this.$emit('success');
          }).finally(() => {
            this.loading = false;
          });
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.task-info-bar {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 10px 14px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #606266;

  .label { color: #909399; }
  .value { font-weight: 500; }
}
</style>
